/* istanbul ignore file */
import { ConfigType } from "./config.d";

const config: ConfigType = {
  market: "MY",
  currencyCode: "MYR",
  color: "#0081c6",
  shouldExtendsFields: true,
  needQualityGate: false,
  buildingField: "level5",
  website: "iproperty.com.my",
  GTMContainerId: "GTM-PGMTX5C",
  crossListingSurveyCookieName: "x-cross-listing-survey",
  geoRedemptionModalLocalStorageName: "x-geo-redemption-modal",
  crossListingOnBoardingModalLocalStorageName:
    "x-cross-listing-onboarding-modal",
  introduceBuyTooltipLocalStorageName: "x-introduce-buy-tooltip",
  purchaseButtonTooltipLocalStorageName: "x-purchase-button-tooltip",
  subscriptionRenewOnlineTooltipLocalStorageName:
    "x-subscription-renew-online-button-tooltip",
  createListingAutoUpgradeTooltipStorageName:
    "x-create-listing-auto-upgrade-tooltip",
  createListingAutoUpgradeTooltipMax: 3,
  proListingInsightTooltipLocalStorageName: "x-pro-listing-insight-tooltip",
  agentNetListingInsightTooltipLocalStorageName:
    "x-agentnet-listing-insight-tooltip",
  agentNetListingPerformanceReportTooltipLocalStorageName:
    "x-agentnet-listing-performance-report-tooltip",
  paymentResultReferrer: "x-payment-result-referrer",
  leadManagementOnBoardingLocalStorageName:
    "x-lead-management-onboarding-tooltip",
  introduceLeadManagementTooltipLocalStorageName:
    "x-introduce-lead-management-tooltip",
  leadUnreadCountCookieName: "x-lead-unread-count",
  lsotListingCreationOnBoardingLocalStorageName:
    "x-lsot-listing-creation-onboarding-tooltip",
  repricingOnBoardingModalLocalStorageName: "x-repricing-onboarding-modal",
  repricingOnBoardingTooltipLocalStorageName: "x-repricing-onboarding-tooltip",
  listingCreationStep1MessageAddOn: "x-listing-creation-step1-message-add-on",
  crossListingOnboardingTooltipLocalStorageName:
    "x-cross-listing-onboarding-tooltip",
  listingDurationChangeTooltipLocalStorageName:
    "x-listing-duration-change-tooltip",
  listingDurationChangeTooltipMax: 10,
  listingsV3OnboardingTooltipLocalStorageName:
    "x-listings-v3-onboarding-tooltip",
  listingsV3RedDotLocalStorageName: "x-listings-v3-red-dot",
  brickzOnboardingTooltipLocalStorageName: "x-brickz-onboarding-tooltip",
};

export default config;
